import type { BooleanFilterState } from '../../../../../common/constants/filters/boolean-filter/types';
import { ProductKeys, type ProductKeys1P } from '../../../../../common/constants/product-keys';
import { createBooleanFilter } from '../../../../filters/boolean-filter/create-boolean-filter';

const productKeys1P: ProductKeys1P[] = [
	ProductKeys.Jira,
	ProductKeys.JiraProductDiscovery,
	ProductKeys.JiraServiceManagement,
	ProductKeys.CustomerServiceManagement,
];

export const filter: Readonly<{
	id: 'watchedByMe';
	type: 'boolean';
	queryParams: {
		key: string;
		getState: (
			queryParams: Record<string, string[]>,
			cloudId: string,
		) => BooleanFilterState<'watchedByMe'>;
	};
	products: ProductKeys[];
	universal: boolean;
	customValueFields?: string[];
	withState: (
		state: unknown,
		config: import('../../../../../common/constants/filters/cloud-config/types').CloudConfig,
	) => import('../../../../../common/constants/filters/boolean-filter/types').BooleanFilterMonad<'watchedByMe'>;
	getInitialState: (
		config: import('../../../../../common/constants/filters/cloud-config/types').CloudConfig,
	) => import('../../../../../common/constants/filters/boolean-filter/types').BooleanFilterMonad<'watchedByMe'>;
	isCompatible: (filterId?: string) => boolean;
	isSupportCustomValue: boolean;
	isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createBooleanFilter({
	id: 'watchedByMe',
	queryParams: { key: 'jWatchedByMe' },
	products: [...productKeys1P],
	alwaysVisible: true,
	universal: false,
});
